import React, { Component } from 'react';
import { message } from 'antd';
import { connect } from 'dva';
import styles from './index.less';
import deleteIcon from '../../images/delete.svg';
import downIcon from '../../images/down.svg';
import upIcon from '../../images/up.svg';
import { getAppCode } from '../../../../utils/utils';

@connect(({ microToPublic }) => ({
  ...microToPublic,
}))
class SelectList extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'microToPublic/fetchGetOrgType',
    });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        selectedRow: [],
        selectedRowKeys: [],
      },
    });
  }

  fetchNewsPreview = () => {
    const { dispatch, selectedRow = [] } = this.props;
    const ids = [];
    selectedRow.forEach(item => {
      ids.push(item.id);
    });
    dispatch({
      type: 'microToPublic/fetchNewsPreview',
      params: {
        id: ids.join(','),
        appCode: getAppCode(),
      },
    })
      .then(() => {
        message.success('预览发布成功');
      })
      .catch(() => {
        dispatch({
          type: 'microToPublic/saveState',
          payload: { spinning: false },
        });
      });
  };

  upItem = (record, index) => {
    const { dispatch, selectedRow = [] } = this.props;
    const tempArr = [];
    selectedRow.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num + 1) {
          tempArr.push(record);
        }
        tempArr.push(item);
      }
    });
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        selectedRow: tempArr,
      },
    });
  };

  downItem = (record, index) => {
    const { dispatch, selectedRow = [] } = this.props;
    const tempArr = [];
    selectedRow.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num - 1) {
          tempArr.push(item);
          tempArr.push(record);
        } else {
          tempArr.push(item);
        }
      }
    });
    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        selectedRow: tempArr,
      },
    });
  };

  deleteItem = record => {
    const { dispatch, selectedRow = [] } = this.props;
    const tempArr = [];
    const idArr = [];
    selectedRow.forEach(item => {
      if (item.id !== record.id) {
        tempArr.push(item);
        idArr.push(item.id);
      }
    });

    dispatch({
      type: 'microToPublic/saveState',
      payload: {
        selectedRow: tempArr,
        selectedRowKeys: idArr,
      },
    });
  };

  renderList = selectedNum => {
    const { selectedRow = [] } = this.props;
    return (
      <div className="list-wrap">
        {selectedRow.map((item, index) => {
          if (index === 0) {
            return this.renderFirst(item, index, selectedNum);
          }
          return this.renderCommon(item, index, selectedNum);
        })}
      </div>
    );
  };

  renderCommon = (record, index, selectedNum) => {
    return (
      <div className="common-item">
        <div className="list-item-title">
          <div>{record.title}</div>
          <img src={record.coverPicFileUrl} alt="" />
        </div>
        <div className="action">
          <span className="mask" />
          <img className="up-icon" src={upIcon} onClick={() => this.upItem(record, index)} alt="" />
          {index !== selectedNum - 1 && (
            <img
              className="down-icon"
              src={downIcon}
              onClick={() => this.downItem(record, index)}
              alt=""
            />
          )}
          <img
            className="delete-icon"
            src={deleteIcon}
            onClick={() => this.deleteItem(record)}
            alt=""
          />
        </div>
      </div>
    );
  };

  renderFirst = (record, index, selectedNum) => {
    return (
      <div className="common-item first-item">
        <div className="cover">
          <img src={record.coverPicFileUrl} alt="" />
          <>
            <span className="mask" />
            <span className="text">{record.title}</span>
          </>
        </div>
        <div className="action">
          <span className="mask" />
          {selectedNum > 1 && (
            <img
              className="down-icon"
              src={downIcon}
              onClick={() => this.downItem(record, index)}
              alt=""
            />
          )}
          <img
            className="delete-icon"
            src={deleteIcon}
            onClick={() => this.deleteItem(record)}
            alt=""
          />
        </div>
      </div>
    );
  };

  renderTips = () => {
    const { type } = this.props;
    if (type === 'batchPush') {
      return <div className="singleMost"> 单次最多可推送8篇文章</div>;
    }
    return (
      <div className="singleMost">
        单次最多可同步8篇文章，外链文章、文章中存在链接不可 同步，文章中附件内容无法同步至公众号
      </div>
    );
  };

  render() {
    const { selectedRow = [] } = this.props;
    const selectedNum = selectedRow.length;
    return (
      <div className={styles.root}>
        <section className="select-list">
          <div className="title">
            已选文章({selectedNum}){this.renderTips()}
          </div>
          {selectedNum === 0 ? (
            <div className="no-data">请在右侧列表选择资讯内容</div>
          ) : (
            this.renderList(selectedNum)
          )}
        </section>
        {/* {renderFooter(selectedNum)} */}
      </div>
    );
  }
}
export default SelectList;
